const Biotechnologydata = [
    {
        id : "1",
        schemeName: "Vaccine Research and Development",
        discription:"Recognizing the importance of vaccines as the most cost-effective health intervention for controlling infectious disease burden, the Department of Biotechnology (DBT) has made concerted efforts in the past three decades, towards strengthening vaccine research and development in India.",
        launchDate: "20th August, 2021.",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Public Health and Nutrition.",
    discription:"The programme was initiated in 1994 as “Food and Nutrition. The thrust from the beginning of the programme was to develop technological and clinical solutions for the Nutrition related problems like malnutrition, anemia, diarrhoea, stunting etc.",
    launchDate: " March 2018",
    AnualFund: "12345"},

    {id : "3",
    schemeName: "Stem Cells & Regenerative Medicine.",
    discription:"The ability of stem cells to self-renew and give rise to subsequent generations with variable degrees of differentiation capacities, offers significant potential for generation of tissues that can potentially replace diseased and damaged areas in the body, with minimal risk of rejection and side effects. Keeping in view the therapeutic applications of these cells, the DBT has identified this area as one of its thrust areas since 2001.",
    launchDate: " 6 July 1973",
    AnualFund: "12345"},
]
export default Biotechnologydata;